import React from 'react';
import {Route,Redirect} from 'react-router-dom';
import {keyTokenLogin} from "../../util/constants";
import {getStorage} from "../../actions";
import {routes} from "../../util/config";

export const ProtectedPages = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            getStorage(keyTokenLogin) != null ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: routes.login,
                        state: { from: props.location }
                    }}
                />
            )
        }
    />
);



// WEBPACK FOOTER //
// ./src/shared/protectedPages/protectedPages.js